import { animated, easings, useSpring } from '@react-spring/web';
import type { FC } from 'react';
import { cn } from '@/shared/react';
import backgroundImage from './assets/background.webp';
import chipsImage from './assets/chips.webp?w=600&quality=95&format=png&effort=max&img';

export const HERO_PRELOAD_IMAGES = [backgroundImage, chipsImage];

export const HeroBackground: FC<{ className?: string }> = ({ className }) => {
  const bgSpring = useSpring({
    from: { y: -235, opacity: 0, filter: 'blur(5px)' },
    to: { y: 0, opacity: 1, filter: 'none' },
    duration: 5000,
  });

  const chipsSpring = useSpring({
    from: { y: 45, opacity: 0 },
    to: { y: 0, opacity: 1 },
    duration: 15000,
    config: { easing: easings.easeInBounce },
  });

  return (
    <div className={cn(className)}>
      <animated.img
        src={backgroundImage}
        alt="Background"
        style={bgSpring}
        className="w-full left-0 h-[250px] desktop:h-[85%] object-cover desktop:object-contain object-top absolute"
        fetchPriority="high"
      />
      <animated.img
        src={chipsImage}
        alt="Chips"
        style={chipsSpring}
        className="w-[600px] hidden desktop:block left-1/2 -translate-x-1/2 object-center object-contain top-1/3 absolute opacity-100"
        fetchPriority="high"
      />
    </div>
  );
};
